module.exports = __webpack_public_path__ + "static/heroku-092e683fd9d47adbab906437e12233cb.png";